export enum ResourceStatus
{
    Error = -1, Empty, DefinitionLoading, DefinitionLoaded, Preloading, Preloaded, Loading, Loaded
}

export enum ResourceType
{
    Image, JSON, Default
}

export enum ApplicationState
{
    Zooming, Animation
}

export enum Phase
{
    Original, Crossfade, Mosaic, WaitForRefocus, Refocus
}

